import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { SupplierInfoComponent } from '@app/cp/shared/contact/supplier-info/supplier-info.component';
import { AfterHoursPOConfirmData } from '../../shared/models/AfterHoursPOConfirmData';
import { v_SupplierLocationBus } from '../../shared/models/v_SupplierLocation';
import { FormGroup, FormControl } from '@angular/forms';
import { ok } from 'assert';

@Component({
    selector: 'cp-after-hours-po',
    templateUrl: './after-hours-po.component.html',
    styleUrls: ['./after-hours-po.component.scss'],
    standalone: false
})
export class AfterHoursPoComponent {
    constructor(globals: GlobalsService, private svc_data: DispatchesService) {
        this.afterHoursForm = new FormGroup({
            requestedById: new FormControl()
        });
    }
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

    afterHoursForm: FormGroup;
    active: boolean = false;
    data: any;
    dialogData: AfterHoursPOConfirmData = new AfterHoursPOConfirmData();
    action: CRUDActions = CRUDActions.Create;
    title: string = "Create Zuggit PO";
    message: string;
    code: string = "CREATE_AFTER_HOURS_PO";
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;
    }
    ok() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.ok, data: this.dialogData, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        this.dialogData = new AfterHoursPOConfirmData();
        this.afterHoursForm.reset();
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        this.dialogData = new AfterHoursPOConfirmData();
        this.afterHoursForm.reset();
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {
        this.afterHoursForm.reset();
        this.active = true;
    }

    private supplierChanged(data: v_SupplierLocationBus) {
        this.dialogData.supplierId = data?.supplierId;
        this.dialogData.supplierLocationId = data?.supplierLocationId;
    }
    private requestorValueChange(data: string) {
        this.dialogData.requestorId = data;
    }

    get canSubmit(): boolean {
        return (this.dialogData.supplierId != null && this.dialogData.supplierLocationId != null && this.dialogData.requestorId != null);
    }
}
